<vdw-header [title]="title" svgIcon="planning-blue"></vdw-header>

<article class="flex-column dialog-content">
  <h3 class="font-weight-semibold order-title">{{ planningOrder.productionOrder.name }}</h3>
  <div class="flex-row">
    <ng-container *ngIf="planningOrder.productionOrder.completed && planningOrder.efficiency">
      <div class="planning-order-info">
        <p class="b1 planning-order-text">{{ planningOrder.efficiency | number: '1.0-2' }}%</p>
      </div>
    </ng-container>

    <div class="flex-row planning-order-info">
      <mat-icon class="production-order-status" [svgIcon]="iconNameForProductionStatus"></mat-icon>
      <p class="b1 planning-order-text">{{ 'PRODUCTION_ORDER.STATUS.' + planningOrder.productionOrder.status | bmsTranslate }}</p>
    </div>

    <ng-container *ngIf="!planningOrder.productionOrder.completed">
      <div *ngIf="differentConfiguration" class="flex-row planning-order-info">
        <mat-icon svgIcon="deviating"></mat-icon>
        <p class="b1 planning-order-text">{{ 'PLANNING.STATUS.DIFFERENT_CONFIGURATION' | bmsTranslate }}</p>
      </div>
      <div *ngIf="planningOrder.isProductionOrderDueDateBeforeEndDate" class="flex-row planning-order-info">
        <mat-icon svgIcon="clock"></mat-icon>
        <p class="b1 planning-order-text">{{ 'PLANNING.STATUS.DUE' | bmsTranslate }}</p>
      </div>
    </ng-container>
  </div>
</article>
